import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

// React Bootstrap Components
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  ButtonToolbar,
} from "react-bootstrap";

// Component Imports
import CustomerProfiling from "./Classification_summary/customer_profiling/customer_profiling";
import Sales from "../pawnshop_dashboard/Inventory_summary/sales";
import InventoryBarGraph from "../pawnshop_dashboard/Inventory_summary/inventory/InventoryBarGraph";
import BranchCategoryView from "./Classification_summary/branch_category/branch_category";
import UnredeemedPawnView from "./Classification_summary/unredeemed_pawn/unredeemed_pawn";
import PackagePieChart from "./Classification_summary/package/package";
import RankingView from "../pawnshop_dashboard/Inventory_summary/rankings/ranking_provider";
import GeneralFilter from "./view_filters/General/GeneralFilter";

// Context and Helper Imports
import { DashboardContext } from "./dashboard_context";
import { moduleNames } from "../../helpers/dashboardModuleNames";
import { openModal, closeModal } from "../../store/actions/ModalActions";

// Redux Action Imports
import * as BranchCategoryActions from "../../store/actions/reports/branch_category_service_actions";
import * as CustomerProfilingActions from "../../store/actions/reports/customer_profiling_service_actions";
import * as InventoryTargetActions from "../../store/actions/reports/inventory_target_actions";
import * as PackageActions from "../../store/actions/reports/package_service_actions";
import * as PreviousMonthAverageActions from "../../store/actions/reports/previous_month_average_service_actions";
import * as SalesActions from "../../store/actions/reports/sales_service_actions";
import * as UnredeemedPawnActions from "../../store/actions/reports/unredeemedpawn_service_actions";

import * as BranchCategoryActions_v4 from "../../store/actions/reports-v4/branch_category_service_actions";
import * as CustomerProfilingActions_v4 from "../../store/actions/reports-v4/customer_profiling_service_actions";
import * as InventoryTargetActions_v4 from "../../store/actions/reports-v4/inventory_target_actions";
import * as PackageActions_v4 from "../../store/actions/reports-v4/package_service_actions";
import * as PreviousMonthAverageActions_v4 from "../../store/actions/reports-v4/previous_month_average_service_actions";
import * as SalesActions_v4 from "../../store/actions/reports-v4/sales_service_actions";
import * as UnredeemedPawnActions_v4 from "../../store/actions/reports-v4/unredeemedpawn_service_actions";

// Charting and Styling Imports
import {
  SetChartTitles,
  ClearChartTitles,
  SetChartRankingTitle,
  SetChartSalesAverageTitle,
  SetChartSalesActiveTitle,
  SetChartSalesExpiredTitle,
  SetChartInventoryTargetTitle,
  SetChartBranchCategoryTitle,
  SetChartPackagesTitle,
  SetChartCustomerProfilingTitle,
  SetChartUnredeemedPawnsTitle,
} from "../../store/actions/reports/chart_title_actions";
import { default as Joyride, STATUS, EVENTS, ACTIONS } from "react-joyride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

// Other Helper Function Imports
import { renderChartTitle } from "../../helpers/chartTitleBuilder";
import { Typography } from "@material-ui/core";

class Pawnshop_Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_view: "cluster",
      current_view_text:
        "Average Pawns Accepted of All Clusters for the month of",
      area_codes: [],
      branch_codes: [],

      run: false,
      stepIndex: 0,
      steps: [
        {
          title: "Average Pawns Accepted",
          target: ".pma",
          content: "This will show the sales of Cluster and Areas.",
          placement: "right-end",
          disableBeacon: true,
        },
        {
          title: "Pawns",
          target: ".sales",
          content:
            "This is where you can see the Active, Average and Expired Pieces and Principal",
          placement: "top",
        },
        {
          title: "Pawns Target Inventory",
          target: ".inventory_target",
          content:
            "This will show you the Target and Active Inventory within a period",
          placement: "auto",
        },
        {
          title: "Packages",
          target: ".packages",
          content:
            "This will display the Principal and Pieces of availed Packages",
          placement: "auto",
        },
        {
          title: "Unredeemed Pawns",
          target: ".unredeemed_pawns",
          content:
            "This will display the Principal and Pieces of per Unredeemed Pawn",
          placement: "auto",
        },
        {
          title: "Branch Categories",
          target: ".branch_category",
          content:
            "This will display the Principal and Pieces per Branch category",
          placement: "auto",
        },
        {
          title: "Customer Profiling",
          target: ".customer_profiling",
          content:
            "This will display the Principal and Pieces per Customer Type",
          placement: "auto",
        },
      ],

      titleColor: "#01579B",
      generalFilterTitle: "Filter",

      cluster_ranking_dataset: [],
      area_ranking_dataset: [],
      average_sales_dataset: [],
      active_sales_dataset: [],
      expired_sales_dataset: [],
      branch_category_dataset: [],
      inventory_target_dataset: [],
      customer_profiling_dataset: [],
      unredeemed_pawns_dataset: [],
    };
  }

  renderButtonTitle = (
    scope,
    cluster,
    area,
    branch,
    scopedateStart,
    scopedateEnd,
    isGeneralFilterInDateRange
  ) => {
    var result = isGeneralFilterInDateRange
      ? `${this.renderScopeIdentifier(
          scope,
          cluster,
          area,
          branch,
          isGeneralFilterInDateRange
        )} 
    Pawns Inventory Summary from  ${scopedateStart} to ${scopedateEnd}`
      : `${this.renderScopeIdentifier(
          scope,
          cluster,
          area,
          branch,
          isGeneralFilterInDateRange
        )} 
    Pawns Inventory Summary as of  ${scopedateStart}`;

    return result;
  };

  renderScopeIdentifier = (scope, cluster, area, branch) => {
    switch (scope) {
      case "SpecificCluster":
        return cluster;

      case "SpecificArea":
        return area;

      case "SpecificBranch":
        return branch;

      default:
        return "";
    }
  };

  _manageTitles = (parameters) => {
    var {
      scopeDate,
      scopeDateEnd,
      operationScope,
      selectedArea,
      selectedCluster,
      selectedBranches,
      diagramsToFilter,
      isRunningBalance,
      isGeneralFilterInDateRange,
    } = parameters;

    var formattedStartScopeDate = moment(scopeDate).format("MMMM DD YYYY");
    var formattedEndScopeDate = moment(scopeDateEnd).format("MMMM DD YYYY");

    var title = this.renderButtonTitle(
      operationScope,
      selectedCluster !== null ? selectedCluster.label : "",
      selectedArea !== null ? selectedArea.label : "",
      `${
        selectedBranches.length > 1 ? "Branches" : "Branch"
      } : ${selectedBranches.map((item) => item.value).join()}`,
      formattedStartScopeDate,
      formattedEndScopeDate,
      isGeneralFilterInDateRange
    );

    var cluster = selectedCluster ? selectedCluster.label : "";
    var area = selectedArea ? selectedArea.label : "";
    var branches = selectedBranches
      ? `${selectedBranches.map((x) => x.value).join(", ")}`
      : "";

    this.setState({ generalFilterTitle: title });
    // this.props.ClearChartTitles();

    const updateChartTitles = (moduleName) => {
      const updatedTitles = renderChartTitle(
        moduleNames[moduleName],
        operationScope,
        formattedStartScopeDate,
        formattedEndScopeDate,
        cluster,
        area,
        branches,
        isRunningBalance
      );

      if (moduleName === "ranking") {
        this.props.SetChartRankingTitle(updatedTitles);
      }
      if (moduleName === "salesAverage") {
        this.props.SetChartSalesAverageTitle(updatedTitles);
      }
      if (moduleName === "salesActive") {
        this.props.SetChartSalesActiveTitle(updatedTitles);
      }
      if (moduleName === "salesExpired") {
        this.props.SetChartSalesExpiredTitle(updatedTitles);
      }
      if (moduleName === "inventoryTarget") {
        this.props.SetChartInventoryTargetTitle(updatedTitles);
      }
      if (moduleName === "branchCategory") {
        this.props.SetChartBranchCategoryTitle(updatedTitles);
      }
      if (moduleName === "packages") {
        this.props.SetChartPackagesTitle(updatedTitles);
      }
      if (moduleName === "customerProfiling") {
        this.props.SetChartCustomerProfilingTitle(updatedTitles);
      }
      if (moduleName === "unredeemedPawns") {
        this.props.SetChartUnredeemedPawnsTitle(updatedTitles);
      }
    };

    const modules = [
      "ranking",
      "salesAverage",
      "salesActive",
      "salesExpired",
      "inventoryTarget",
      "branchCategory",
      "packages",
      "customerProfiling",
      "unredeemedPawns",
    ];

    modules.forEach((module) => {
      if (diagramsToFilter[module]) {
        updateChartTitles(module);
      }
    });
  };

  _manageParameters = (parameters) => {
    var {
      scopeDate,
      scopeDateEnd,
      operationScope,
      selectedArea,
      selectedCluster,
      selectedBranches,
      isRunningBalance,
      isGeneralFilterInDateRange,
    } = parameters;

    //contains sources from all of organization of ppg
    const { pepp_hierarchy, master_area, master_cluster } = this.props;

    const isV3 = isGeneralFilterInDateRange === true;

    //Base start date
    const startDate = new Date(scopeDate);

    //Base end date
    const endDate = new Date(scopeDateEnd);

    //ranges backward 12 months before the current date
    const firstMonthOfYearRaw = moment(startDate).subtract(12, "months");

    //use this for variables
    const firstMonthOfYear = firstMonthOfYearRaw.toDate();

    // maps dates specific for active and expired sales
    const activeAndExpiredDates =
      this.getAssignedActiveAndExpiredDates(startDate);

    // maps last month from start date
    const lastMonth = this.getLastMonth(startDate);

    // maps last year from startDate
    const lastYear = this.getLastYear(startDate);

    // detects of date was leap year
    const isLeapYear = moment(startDate).isLeapYear();

    // all clusters
    const all_clusters = master_cluster.map((d) => d.id);

    // manages ranges for
    const monthAndYearRanges = {
      from_month: moment(lastYear).format("MM"),
      from_year: moment(lastYear).format("YYYY"),
      to_month: moment(startDate).format("MM"),
      to_year: moment(startDate).format("YYYY"),
    };

    const averageSalesRangesBase = [
      { current: startDate, previous: lastYear },
      { current: startDate, previous: lastMonth },
    ];

    const averageSalesRanges = averageSalesRangesBase.map((date) => {
      return {
        currentMonth: moment(date.current).format("MM"),
        currentYear: moment(date.current).format("YYYY"),
        previousMonth: moment(date.previous).format("MM"),
        previousYear: moment(date.previous).format("YYYY"),
      };
    });

    // manages covered date if ranged or not
    const coveredDateRange = {
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(startDate).format("YYYY-MM-DD"),
    };

    const runningBalanceDateRange = {
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(endDate).format("YYYY-MM-DD"),
    };

    // maps the clusterId;
    const clusterId = selectedCluster ? selectedCluster.value : 0;
    // maps the selected area
    const areaId = selectedArea ? selectedArea.value : "";
    // maps the selected branch
    const branch_codes = selectedBranches
      ? selectedBranches.map((_) => _.value)
      : [];

    /// manages api parameters
    const RANGES = {
      ranking: {
        overall: {
          month: startDate.getMonth() + 1,
          year: startDate.getFullYear(),
          cluster_ids: all_clusters,
        },
      },
      inventoryTarget: {
        overall: {
          ...monthAndYearRanges,
        },
        cluster: {
          clusterId,
          ...monthAndYearRanges,
        },
        area: {
          areaId,
          ...monthAndYearRanges,
        },
        branch: {
          branch_codes,
          ...monthAndYearRanges,
        },
      },
      unredeemedPawns: {
        overall: {
          dates: coveredDateRange,
        },
        cluster: {
          clusterId,
          dates: coveredDateRange,
        },
        area: {
          areaId,
          dates: coveredDateRange,
        },
        branch: {
          branch_codes,
          dates: coveredDateRange,
        },
      },
      branchCategory: {
        overall: {
          dates: coveredDateRange,
        },
        cluster: {
          clusterId,
          dates: coveredDateRange,
        },
        area: {
          areaId,
          dates: coveredDateRange,
        },
        branch: {
          branch_codes,
          dates: coveredDateRange,
        },
      },
      packages: {
        overall: {
          dates: coveredDateRange,
        },
        cluster: {
          clusterId,
          dates: coveredDateRange,
        },
        area: {
          areaId,
          dates: coveredDateRange,
        },
        branch: {
          branch_codes,
          dates: coveredDateRange,
        },
      },
      customerProfiling: {
        overall: {
          dates: coveredDateRange,
        },
        cluster: {
          clusterId,
          dates: coveredDateRange,
        },
        area: {
          areaId,
          dates: coveredDateRange,
        },
        branch: {
          branch_codes,
          dates: coveredDateRange,
        },
      },
      sales: {
        active: {
          overall: {
            dates: !isV3 ? activeAndExpiredDates : runningBalanceDateRange,
          },
          cluster: {
            clusterId,
            dates: !isV3 ? activeAndExpiredDates : runningBalanceDateRange,
          },
          area: {
            areaId,
            dates: !isV3 ? activeAndExpiredDates : runningBalanceDateRange,
          },
          branch: {
            branch_codes,
            dates: !isV3 ? activeAndExpiredDates : runningBalanceDateRange,
          },
        },
        expired: {
          overall: {
            dates: !isV3 ? activeAndExpiredDates : coveredDateRange,
          },
          cluster: {
            clusterId,
            dates: !isV3 ? activeAndExpiredDates : coveredDateRange,
          },
          area: {
            areaId,
            dates: !isV3 ? activeAndExpiredDates : coveredDateRange,
          },
          branch: {
            branch_codes,
            dates: !isV3 ? activeAndExpiredDates : coveredDateRange,
          },
        },
        average: {
          overall: {
            dates: averageSalesRanges,
          },
          cluster: {
            clusterId,
            dates: averageSalesRanges,
          },
          area: {
            areaId,
            dates: averageSalesRanges,
          },
          branch: {
            branch_codes,
            dates: averageSalesRanges,
          },
        },
      },
    };
    return { RANGES, isRanged: isGeneralFilterInDateRange };
  };

  _manageMethods = (parameters) => {
    const { diagramsToFilter, isGeneralFilterInDateRange } = parameters;

    const isRanged = isGeneralFilterInDateRange === true;

    const ranking = {
      overall: this.props.GetPreviousMonthAverageClusterV4,
      cluster: null,
      area: null,
      branch: null,
    };

    const inventoryTarget = {
      overall: this.props.GetInventoryTargetOverallV4,
      cluster: this.props.GetInventoryTargetClusterV4,
      area: this.props.GetInventoryTargetAreaV4,
      branch: this.props.GetInventoryTargetBranchV4,
    };

    const unredeemedPawns = {
      overall: this.props.GetUnredeemedPawnOverallV4,
      cluster: this.props.GetUnredeemedPawnClusterV4,
      area: this.props.GetUnredeemedPawnAreaV4,
      branch: this.props.GetUnredeemedPawnBranchV4,
    };

    const branchCategory = {
      overall: this.props.GetBranchCategoryOverallV4,

      cluster: this.props.GetBranchCategoryClusterV4,

      area: this.props.GetBranchCategoryAreaV4,

      branch: this.props.GetBranchCategoryBranchV4,
    };

    const packages = {
      overall: this.props.GetPackageOverallV4,

      cluster: this.props.GetPackageClusterV4,

      area: this.props.GetPackageAreaV4,

      branch: this.props.GetPackageBranchV4,
    };

    const customerProfiling = {
      overall: this.props.GetCustomerProfileOverallV4,

      cluster: this.props.GetCustomerProfileClusterV4,

      area: this.props.GetCustomerProfileAreaV4,

      branch: this.props.GetCustomerProfileBranchV4,
    };

    const sales_active = {
      overall: this.props.GetOverallActive_v4,

      cluster: this.props.GetActiveByCluster_v4,

      area: this.props.GetActiveByArea_v4,

      branch: this.props.GetActiveByBranch_v4,
    };

    const sales_average = {
      overall: this.props.GetOverallAverage_v4,

      cluster: this.props.GetAverageByCluster_v4,

      area: this.props.GetAverageByArea_v4,

      branch: this.props.GetAverageByBranch_v4,
    };

    const sales_expired = {
      overall: this.props.GetOverallExpired_v4,

      cluster: this.props.GetExpiredByCluster_v4,

      area: this.props.GetExpiredByArea_v4,

      branch: this.props.GetExpiredByBranch_v4,
    };

    return {
      METHODS: {
        RANKING: ranking,
        INVENTORY_TARGET: inventoryTarget,
        UNREDEEMED_PAWNS: unredeemedPawns,
        BRANCH_CATEGORY: branchCategory,
        PACKAGES: packages,
        CUSTOMER_PROFILES: customerProfiling,
        SALES_ACTIVE: sales_active,
        SALES_AVERAGE: sales_average,
        SALES_EXPIRED: sales_expired,
      },
    };
  };

  _filterOverall = (parameters) => {
    const { diagramsToFilter, operationScope } = parameters;

    this._manageTitles(parameters);

    const { RANGES } = this._manageParameters(parameters);

    const { METHODS } = this._manageMethods(parameters);

    const promises = [];

    switch (operationScope) {
      case "Overall":
        if (diagramsToFilter.ranking === true) {
          promises.push(METHODS.RANKING.overall(RANGES.ranking.overall));
        }
        if (diagramsToFilter.inventoryTarget === true) {
          promises.push(
            METHODS.INVENTORY_TARGET.overall(RANGES.inventoryTarget.overall)
          );
        }
        if (diagramsToFilter.unredeemedPawns === true) {
          promises.push(
            METHODS.UNREDEEMED_PAWNS.overall(RANGES.unredeemedPawns.overall)
          );
        }
        if (diagramsToFilter.branchCategory === true) {
          promises.push(
            METHODS.BRANCH_CATEGORY.overall(RANGES.branchCategory.overall)
          );
        }
        if (diagramsToFilter.packages === true) {
          promises.push(METHODS.PACKAGES.overall(RANGES.packages.overall));
        }
        if (diagramsToFilter.customerProfiling === true) {
          promises.push(
            METHODS.CUSTOMER_PROFILES.overall(RANGES.customerProfiling.overall)
          );
        }
        if (diagramsToFilter.salesAverage === true) {
          promises.push(
            METHODS.SALES_AVERAGE.overall(RANGES.sales.average.overall)
          );
        }
        if (diagramsToFilter.salesActive === true) {
          promises.push(
            METHODS.SALES_ACTIVE.overall(RANGES.sales.active.overall)
          );
        }
        if (diagramsToFilter.salesExpired === true) {
          promises.push(
            METHODS.SALES_EXPIRED.overall(RANGES.sales.expired.overall)
          );
        }
        break;
      case "SpecificCluster":
        if (diagramsToFilter.inventoryTarget === true) {
          promises.push(
            METHODS.INVENTORY_TARGET.cluster(RANGES.inventoryTarget.cluster)
          );
        }
        if (diagramsToFilter.unredeemedPawns === true) {
          promises.push(
            METHODS.UNREDEEMED_PAWNS.cluster(RANGES.unredeemedPawns.cluster)
          );
        }
        if (diagramsToFilter.branchCategory === true) {
          promises.push(
            METHODS.BRANCH_CATEGORY.cluster(RANGES.branchCategory.cluster)
          );
        }
        if (diagramsToFilter.packages === true) {
          promises.push(METHODS.PACKAGES.cluster(RANGES.packages.cluster));
        }
        if (diagramsToFilter.customerProfiling === true) {
          promises.push(
            METHODS.CUSTOMER_PROFILES.cluster(RANGES.customerProfiling.cluster)
          );
        }
        if (diagramsToFilter.salesAverage === true) {
          promises.push(
            METHODS.SALES_AVERAGE.cluster(RANGES.sales.average.cluster)
          );
        }
        if (diagramsToFilter.salesActive === true) {
          promises.push(
            METHODS.SALES_ACTIVE.cluster(RANGES.sales.active.cluster)
          );
        }
        if (diagramsToFilter.salesExpired === true) {
          promises.push(
            METHODS.SALES_EXPIRED.cluster(RANGES.sales.expired.cluster)
          );
        }
        break;
      case "SpecificArea":
        if (diagramsToFilter.inventoryTarget === true) {
          promises.push(
            METHODS.INVENTORY_TARGET.area(RANGES.inventoryTarget.area)
          );
        }
        if (diagramsToFilter.unredeemedPawns === true) {
          promises.push(
            METHODS.UNREDEEMED_PAWNS.area(RANGES.unredeemedPawns.area)
          );
        }
        if (diagramsToFilter.branchCategory === true) {
          promises.push(
            METHODS.BRANCH_CATEGORY.area(RANGES.branchCategory.area)
          );
        }
        if (diagramsToFilter.packages === true) {
          promises.push(METHODS.PACKAGES.area(RANGES.packages.area));
        }
        if (diagramsToFilter.customerProfiling === true) {
          promises.push(
            METHODS.CUSTOMER_PROFILES.area(RANGES.customerProfiling.area)
          );
        }
        if (diagramsToFilter.salesAverage === true) {
          promises.push(METHODS.SALES_AVERAGE.area(RANGES.sales.average.area));
        }
        if (diagramsToFilter.salesActive === true) {
          promises.push(METHODS.SALES_ACTIVE.area(RANGES.sales.active.area));
        }
        if (diagramsToFilter.salesExpired === true) {
          promises.push(METHODS.SALES_EXPIRED.area(RANGES.sales.expired.area));
        }
        break;
      case "SpecificBranch":
        if (diagramsToFilter.inventoryTarget === true) {
          promises.push(
            METHODS.INVENTORY_TARGET.branch(RANGES.inventoryTarget.branch)
          );
        }
        if (diagramsToFilter.unredeemedPawns === true) {
          promises.push(
            METHODS.UNREDEEMED_PAWNS.branch(RANGES.unredeemedPawns.branch)
          );
        }
        if (diagramsToFilter.branchCategory === true) {
          promises.push(
            METHODS.BRANCH_CATEGORY.branch(RANGES.branchCategory.branch)
          );
        }
        if (diagramsToFilter.packages === true) {
          promises.push(METHODS.PACKAGES.branch(RANGES.packages.branch));
        }
        if (diagramsToFilter.customerProfiling === true) {
          promises.push(
            METHODS.CUSTOMER_PROFILES.branch(RANGES.customerProfiling.branch)
          );
        }
        if (diagramsToFilter.salesAverage === true) {
          promises.push(
            METHODS.SALES_AVERAGE.branch(RANGES.sales.average.branch)
          );
        }
        if (diagramsToFilter.salesActive === true) {
          promises.push(
            METHODS.SALES_ACTIVE.branch(RANGES.sales.active.branch)
          );
        }
        if (diagramsToFilter.salesExpired === true) {
          promises.push(
            METHODS.SALES_EXPIRED.branch(RANGES.sales.expired.branch)
          );
        }
        break;
    }

    return Promise.all(promises);
  };

  handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({ run: false });
    }
  };

  handleRankingTitles = (data) => {
    this.setState({
      current_view: null,
      current_view_text: "",
      area_codes: [],
      branch_codes: [],
    });

    this.setState({
      current_view: data.current_view,
      current_view_text: data.current_view_text,
      area_codes: data.area_codes ? data.area_codes : [],
      branch_codes: data.branch_codes ? data.branch_codes : [],
    });
  };

  render() {
    return (
      <>
        <DashboardContext.Provider
          value={{
            //ranking
            current_view: this.state.current_view,
            current_view_text: this.state.current_view_text,
            area_codes: this.state.area_codes,
            branch_codes: this.state.branch_codes,

            //properties

            titleColor: this.state.titleColor,
            rankingLocked: this.state.rankingLocked,
            salesAverageLocked: this.state.salesAverageLocked,
            salesActiveLocked: this.state.salesActiveLocked,
            salesExpiredLocked: this.state.salesExpiredLocked,
            inventoryTargetLocked: this.state.inventoryTargetLocked,
            branchCategoryLocked: this.state.branchCategoryLocked,
            packagesLocked: this.state.packagesLocked,
            customerProfilingLocked: this.state.customerProfilingLocked,
            unredeemedPawnsLocked: this.state.unredeemedPawnsLocked,

            //datasets
            cluster_ranking_dataset: this.state.cluster_ranking_dataset,
            area_ranking_dataset: this.state.area_ranking_dataset,
            average_sales_dataset: this.state.average_sales_dataset,
            active_sales_dataset: this.state.active_sales_dataset,
            expired_sales_dataset: this.state.expired_sales_dataset,
            branch_category_dataset: this.state.branch_category_dataset,
            inventory_target_dataset: this.state.inventory_target_dataset,
            customer_profiling_dataset: this.state.customer_profiling_dataset,
            unredeemed_pawns_dataset: this.state.unredeemed_pawns_dataset,
          }}
        >
          <Container className="dashboard-main" fluid>
            <Joyride
              autostart
              spotlightClicks={true}
              disableBeacon={true}
              disableScrolling={false}
              disableCloseOnEsc={true}
              disableOverlayClose={true}
              callback={this.handleJoyrideCallback}
              styles={{
                options: {
                  primaryColor: "#26de81",
                  overlayColor: "#1e272e",
                  zIndex: 1000,
                },
              }}
              continuous={true}
              showSkipButton={true}
              showProgress={true}
              run={this.state.run}
              steps={this.state.steps}
            />

            <Row noGutters>
              <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                <Container fluid>
                  <Row noGutters className="mb-2">
                    <Col>
                      <Container
                        fluid
                        className="text-dark bg-white p-3 rounded border-black mb-3 shadow-sm"
                      >
                        <Row>
                          <Col>
                            <div>
                              <h3>Pawns Inventory Summary</h3>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ButtonToolbar className="w-100">
                              <Button
                                className="m-1"
                                onClick={() => {
                                  openModal({
                                    size: "lg",
                                    title: "General Filter",
                                    currentComponent: (
                                      <GeneralFilter
                                        filterOverall={this._filterOverall}
                                      />
                                    ),
                                  });
                                }}
                                size="md"
                                variant="secondary"
                              >
                                <Typography style={{ fontSize: ".9rem" }}>
                                  {this.state.generalFilterTitle}
                                </Typography>
                              </Button>
                              <Button
                                className="m-1"
                                onClick={() => {
                                  this.setState({ run: true });
                                }}
                              >
                                <FontAwesomeIcon icon={faInfoCircle} />
                              </Button>
                            </ButtonToolbar>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                  <Row noGutters>
                    <Col>
                      <Card
                        style={{ borderRadius: 5 }}
                        className="border-black mb-3 shadow-sm pma"
                      >
                        <RankingView
                          {...this.state}
                          handleRankingTitles={this.handleRankingTitles}
                        />
                      </Card>
                      <Card
                        style={{ borderRadius: 5 }}
                        className="border-black mb-3 shadow-sm sales"
                      >
                        <Card.Body>
                          <Card.Title
                            as="h4"
                            style={{ color: this.state.titleColor }}
                          >
                            Pawns
                          </Card.Title>
                          <Sales />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={8}>
                <Container fluid>
                  <Row>
                    <Col>
                      <Card
                        style={{ borderRadius: 5, zIndex: 0 }}
                        className="border-black mb-3 shadow-sm inventory_target"
                      >
                        <Card.Body>
                          <Card.Title
                            as="h4"
                            style={{ color: this.state.titleColor }}
                          >
                            Pawns Target Inventory
                          </Card.Title>
                          <InventoryBarGraph />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <div
                        className="border-black  shadow-sm p-3"
                        style={{ backgroundColor: "#FFFFFF" }}
                      >
                        <h3>Classification Summary</h3>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card className="border-black mb-3 shadow-sm packages">
                        <Card.Body>
                          <Card.Title
                            as="h4"
                            style={{ color: this.state.titleColor }}
                          >
                            Packages
                          </Card.Title>
                          <PackagePieChart {...this.props} />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Card className="border-black mb-3 shadow-sm unredeemed_pawns">
                        <Card.Body>
                          <Card.Title
                            as="h4"
                            style={{ color: this.state.titleColor }}
                          >
                            Unredeemed Pawns
                          </Card.Title>
                          <UnredeemedPawnView {...this.props} />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Row>
                        <Col>
                          <Card className="border-black mb-3 shadow-sm branch_category">
                            <Card.Body>
                              <Card.Title
                                as="h4"
                                style={{ color: this.state.titleColor }}
                              >
                                Branch Categories
                              </Card.Title>
                              <BranchCategoryView {...this.props} />
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <Card className="border-black mb-3 shadow-sm customer_profiling">
                            <Card.Body>
                              <Card.Title
                                as="h4"
                                style={{ color: this.state.titleColor }}
                              >
                                Customer Profiling
                              </Card.Title>
                              <CustomerProfiling {...this.props} />
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </DashboardContext.Provider>
      </>
    );
  }

  getLastMonth = (scopeDate) => {
    var currentMonth = new Date(scopeDate);
    var lastMonth = new Date(moment(scopeDate).subtract(1, "months"));

    lastMonth.setYear(
      currentMonth.getMonth() === 0
        ? currentMonth.getFullYear() - 1
        : currentMonth.getFullYear()
    );
    return new Date(lastMonth);
  };

  getLastYear = (scopeDate) => {
    var currentYear = new Date(scopeDate);
    var lastYear = new Date(scopeDate);
    lastYear.setMonth(currentYear.getMonth());
    lastYear.setYear(currentYear.getFullYear() - 1);
    return new Date(lastYear);
  };

  getAssignedActiveAndExpiredDates = (scopeDate) => {
    var lastMonth = this.getLastMonth(scopeDate);
    var currentDate = new Date(scopeDate);

    if (
      currentDate.getMonth() === 0 &&
      currentDate.getFullYear() === lastMonth.getFullYear()
    ) {
      lastMonth.setYear(lastMonth.getFullYear() - 1);
    }

    var current = moment(currentDate).format("YYYY-MM-DD");
    lastMonth = moment(lastMonth).format("YYYY-MM-DD");
    return [{ coveredDate: current }];
  };
}

const mapStateToProps = (state) => {
  return {
    master_cluster: state.crdm.master_cluster,
    pepp_hierarchy: state.crdm.pepp_hierarchy,
    master_area: state.crdm.master_area,
  };
};

const mapDispatchToProps = {
  closeModal: closeModal,

  SetChartTitles: SetChartTitles,
  ClearChartTitles: ClearChartTitles,
  SetChartRankingTitle: SetChartRankingTitle,
  SetChartSalesAverageTitle: SetChartSalesAverageTitle,
  SetChartSalesActiveTitle: SetChartSalesActiveTitle,
  SetChartSalesExpiredTitle: SetChartSalesExpiredTitle,
  SetChartInventoryTargetTitle: SetChartInventoryTargetTitle,
  SetChartBranchCategoryTitle: SetChartBranchCategoryTitle,
  SetChartPackagesTitle: SetChartPackagesTitle,
  SetChartCustomerProfilingTitle: SetChartCustomerProfilingTitle,
  SetChartUnredeemedPawnsTitle: SetChartUnredeemedPawnsTitle,

  ...CustomerProfilingActions_v4,
  ...PackageActions_v4,
  ...BranchCategoryActions_v4,
  ...InventoryTargetActions_v4,
  ...PreviousMonthAverageActions_v4,
  ...SalesActions_v4,
  ...UnredeemedPawnActions_v4,

  ...CustomerProfilingActions,
  ...PackageActions,
  ...BranchCategoryActions,
  ...InventoryTargetActions,
  ...PreviousMonthAverageActions,
  ...SalesActions,
  ...UnredeemedPawnActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Pawnshop_Dashboard);
